import React, { FunctionComponent, ReactNode } from 'react'
import styled from '@emotion/styled'

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  background-color: black;
  height: 100vh;
  position: relative;
  overflow: auto;
`

const CenteredPage: FunctionComponent<any> = (props: { children: ReactNode }) => (
  <StyledContainer>{props.children}</StyledContainer>
)

export default CenteredPage
